<template>
    <i class="fas fa-question-circle text-primary ml-1" v-bind="$attrs" data-toggle="tooltip"></i>
</template>

<script>
export default {
    props: ['title'],
    mounted() {
        $(this.$el).tooltip({ title: this.title });
    },
    beforeDestroy() {
        $(this.$el).tooltip('dispose');
    }
}
</script>
